<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import $http from './HttpRequest';
import * as VueGoogleMaps from 'vue2-google-maps';
import Vue from 'vue';

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBc14i6_mOTt00Hpv_7JCGCcljpsk2bav8'
    }
});

export default {
  name: 'app',
  data () {
    return {

    }
  },
  created () {
      this.loadFrontInfo();
  },
  methods : {
      loadFrontInfo (){
          let self = this;
          $http.get('/frontend').then( (response)=>{
              if( response.status == 200 )
              {
                  self.$store.state.settings = response.data;
                  self.$store.commit('settings', response.data);
              }
              else
              {
                  debugger;
              }
          }).catch( (err) => {
              alert(err);
          });
      }
  },
}
</script>

<style lang="scss">
#app
{

}
</style>



// WEBPACK FOOTER //
// App.vue?cb784e46